import { useEffect, useRef, useState } from 'react';
import * as Sentry from '@sentry/react';
import { SocketStatus } from '../../../data-models/socket-base.data-model';
import { HudsonWsService } from '../../../services/HudsonWsService';
import { useAgentHealthStatus } from './useAgentHealthStatus';
import { useChatWsStatus } from './useWsChat';

const AutoReconnectCoolDownMs = 30_000;

export function useAutoReconnect() {
  const serverHealth = useAgentHealthStatus();
  const wsStatus = useChatWsStatus();
  const [isAutoReconnecting, setIsAutoReconnecting] = useState(false);
  const lastAttemptRef = useRef<number>(0);

  useEffect(() => {
    const shouldReconnect =
      serverHealth === 'ok' &&
      wsStatus === SocketStatus.error &&
      Date.now() - lastAttemptRef.current > AutoReconnectCoolDownMs;

    if (shouldReconnect && !isAutoReconnecting) {
      setIsAutoReconnecting(true);
      lastAttemptRef.current = Date.now();

      const service = HudsonWsService.get();
      if (service) {
        service.reconnect().finally(() => {
          setIsAutoReconnecting(false);
        });
      } else {
        Sentry.logger.error('[useAutoReconnect] HudsonWsService not initialized');
        setIsAutoReconnecting(false);
      }
    }
  }, [serverHealth, wsStatus, isAutoReconnecting]);

  return { isAutoReconnecting };
}
